export default __webpack_public_path__ + "static/media/coolranch-image.a5039134.png";